import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_PUBLIC_MEDREFILL_PAYMENT_MODES_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type {
  GetMedRefillPaymentModesResponsePayload,
  GetPublicMedRefillPaymentModesRequestPayload,
} from '../types/getMedRefillPaymentModes.type';

export const TAG_PUBLIC_MEDREFILL_PAYMENT_MODES = 'getPublicMedRefillPaymentModes';

export const getPublicMedRefillPaymentModes = <T extends BuilderType>(builder: T) =>
  builder.query<GetMedRefillPaymentModesResponsePayload, GetPublicMedRefillPaymentModesRequestPayload>({
    providesTags: [TAG_PUBLIC_MEDREFILL_PAYMENT_MODES],
    query: (params) => ({
      data: params,
      method: 'POST',
      url: GET_PUBLIC_MEDREFILL_PAYMENT_MODES_URL,
    }),
    transformResponse: (response: GenericApiResponse<GetMedRefillPaymentModesResponsePayload>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }
      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
